export const NoNotes: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className,
  }: {
    className?: string;
  }) => {
    return (
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M30.1016 46.6836H69.8987"
          stroke="currentColor"
          strokeWidth="5.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.1016 66.5822H50.0001"
          stroke="currentColor"
          strokeWidth="5.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.836 20.1522C15.0768 20.1522 13.3897 20.851 12.1458 22.0949C10.902 23.3388 10.2031 25.0259 10.2031 26.785V83.1643C10.2031 84.9233 10.902 86.6107 12.1458 87.8544C13.3897 89.0981 15.0768 89.7972 16.836 89.7972H83.1646C84.9236 89.7972 86.611 89.0981 87.8546 87.8544C89.0983 86.6107 89.7974 84.9233 89.7974 83.1643V26.785C89.7974 25.0259 89.0983 23.3388 87.8546 22.0949C86.611 20.851 84.9236 20.1522 83.1646 20.1522H16.836Z"
          stroke="currentColor"
          strokeWidth="5.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.7852 10.2029V30.1015"
          stroke="currentColor"
          strokeWidth="5.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M73.2148 10.2029V30.1015"
          stroke="currentColor"
          strokeWidth="5.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  